import { useEffect } from 'react';
import useLocalStorage from './useLocalStorage';

const useColorMode = () => {
  const [colorMode, setColorMode] = useLocalStorage('color-theme', 'light');

  useEffect(() => {
    const className = 'dark';
    const htmlElement = window.document.documentElement;

    htmlElement.classList.toggle(className, colorMode === 'dark');
  }, [colorMode]);

  return [colorMode, setColorMode];
};

export default useColorMode;
